/* import __COLOCATED_TEMPLATE__ from './inline-svg.hbs'; */
import { htmlSafe } from '@ember/template';
import { computed } from '@ember/object';
import Component from '@ember/component';
import { INLINE_SVGS } from '../constants/inline-svgs';

const CLASS_NAME = 'SH-c-inline-svg';

export default Component.extend({
  classNames: [CLASS_NAME],
  CLASS_NAME,

  /** @param {String} */
  name: '',

  /** @type {Ember.String.htmlSafe} */
  _svg: computed('name', function () {
    return htmlSafe(INLINE_SVGS[this.get('name')] || '');
  }),
});
